<template>
  <v-app id="inspire">
    <Header v-if="!isLoginRoute" />
    <v-main :class="{'desktop-content': !isLoginRoute}">
      <Main />
    </v-main>
    <v-snackbars :messages.sync="messages" top right timeout='0' color='warning'>
      <template v-slot:action="{ close }">
        <v-btn text @click="close()">Dispensar</v-btn>
      </template>
    </v-snackbars>
  </v-app>
</template>

<script>
import Header from "./components/Header.vue";
import Main from "./components/Main.vue";
import VSnackbars from "v-snackbars"
export default {
  components: {
    Header,
    Main,
    "v-snackbars": VSnackbars,
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    messages: [],
  }),
  computed: {
    isLoginRoute() {
      return this.$route.name === 'Login' || this.$route.name === 'login' || this.$route.path === '/' || this.$route.path === '/login';
    },
  },
  mounted() {
    if (this.$store.getters.getUserData.table_key === 'prefectures') {
      this.$http
        .get(`/parts-and-services/item/alert/${this.$store.getters.getUserData.table_id}`)
        .then((r) => {
          r.data.validity.forEach(item => {
            this.messages.push(`O item ${item.name} vence dia ${this.convertDate(item.validity)}`)
          });
          r.data.qtdMin.forEach(item => {
            this.messages.push(`O item ${item.name} atingiu a quantidade mínima`)
          });
        })
    }
  },
  methods: {
    convertDate(date) {
      if (date) {
        date = date.replace("-", "").replace("-", "");
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        return `${day}/${month}/${year}`;
      } else {
        return false;
      }
    },
  }
};
</script>

<style>
.desktop-content {
  padding-left: 80px !important;
}

@media print {
  /* Hide everything by default when printing */
  body * {
    visibility: hidden;
  }
  
  /* Show only the element with id "reportList" or "conferenceList" and its children */
  #reportList, #reportList *,
  #conferenceList, #conferenceList * {
    visibility: visible;
  }

  /* Position the printable area at the top left */
  #reportList, #conferenceList {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 0 !important;
    visibility: visible;
  }

  /* Ensure colors and backgrounds are preserved */
  .bg-slate-50 { background-color: #f8fafc !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-slate-800 { background-color: #1e293b !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-slate-900 { background-color: #0f172a !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-indigo-900 { background-color: #312e81 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-orange-600 { background-color: #ea580c !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-orange-50 { background-color: #fff7ed !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .bg-white { background-color: #ffffff !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  
  .text-white { color: white !important; }
  .text-orange-600 { color: #ea580c !important; }
  
  /* Hide UI elements specifically */
  .v-navigation-drawer, .v-app-bar, .print-hidden, .v-btn, button {
    display: none !important;
  }

  /* Reset layout for print */
  #inspire, .v-main, .desktop-content {
    padding: 0 !important;
    margin: 0 !important;
    max-width: none !important;
  }
}
</style>
